import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AttachmentFile } from '@common/models/attachmentFileModel';
import { UploadAttachmentVesselAnnouncementDocumentDisplayModel } from '@common/models/uploadAttachmentVesselAnnouncementDocument.display.model';


@Injectable({
    providedIn: 'root',
})
export class DocumentService {
    constructor(private http: HttpClient) {}

    nonHazmatItemsCompleteEntryRequest(vesselAnnouncementDocumentId: number) {
        return this.http.post<any>('api:///documents/SendNonHazmatItemsToCimisCommand', vesselAnnouncementDocumentId);
    }

    hazmatItemsCompleteEntryRequest(vesselAnnouncementDocumentId: number) {
        return this.http.post<any>('api:///documents/SendHazmatItemsToCimisCommand', vesselAnnouncementDocumentId);
    }

    sendCargoAgentsToCimis(vesselAnnouncementDocumentId: number) {
        return this.http.post<any>(`api:///documents/SendCargoAgentsToCimis`, vesselAnnouncementDocumentId);
    }

    createVesselAnnouncementDocumentPdf(documentId: number) {
        return this.http.post<AttachmentFile>(`api:///documents/CreateVesselAnnouncementDocumentPdf/${documentId}`, null);
    }

    synchroniseWithCimis(vesselAnnouncementId: number): Observable<any> {
        return this.http.post<any>(`api:///VesselAnnouncement/ManualCimisSynchronization/${vesselAnnouncementId}`, null);
    }

    declineDocument(id: number) {
        return this.http.post<any>('api:///cimis/DeclineDocument', id);
    }

    approveDocument(documentId: number) {
        return this.http.post<any>('api:///cimis/ApproveDocument', documentId);
    }

    checkFal2DNtrtStatusForDocument(vesselAnnouncementDocumentId: number) {
        return this.http.get<any>(`api:///Documents/checkFal2DNTRTStatusForDocument/${vesselAnnouncementDocumentId}`);
    }

    checkIssStatusForDocument(vesselAnnouncementDocumentId: number) {
        return this.http.get<any>(`api:///Documents/checkIssStatusForDocument/${vesselAnnouncementDocumentId}`);
    }

    getVesselAnnouncementDocumentPdfPreview(documentId: number) {
        return this.http.get<any>(`api:///Documents/GetVesselAnnouncementDocumentPdfPreview/${documentId}`);
    }

    sendSignedDocumentToCimis(fileDto: UploadAttachmentVesselAnnouncementDocumentDisplayModel) {
        return this.http.post('api:///Cimis/SendSignedDocumentToCimis', fileDto);
    }

    saveAttachmentToVesselAnnouncementDocument(fileDto: UploadAttachmentVesselAnnouncementDocumentDisplayModel) {
        return this.http.post('api:///Documents/SaveAttachmentToVesselAnnouncementDocument', fileDto);
    }

    uploadAttachmentVesselAnnouncementDocument(fileDto: UploadAttachmentVesselAnnouncementDocumentDisplayModel) {
        return this.http.post<any>('api:///Cimis/UploadAttachmentVesselAnnouncementDocument', fileDto);
    }
}

